import React from 'react';

export type NonGeneratingUser = {
  consumer_name: string;
  provider_name: string;
  capacity: number | string;
  energy: number | string;
  // Optional arrays for last 3 days energy (oldest -> newest or any order provided by API)
  last_three_days?: Array<number | string>;
  energy_last_three_days?: Array<number | string>;
};

interface NonGeneratingUsersProps {
  users: NonGeneratingUser[];
  headerDates?: string[];
  loading?: boolean;
}

const NonGeneratingUsers: React.FC<NonGeneratingUsersProps> = ({ users, headerDates, loading }) => {
  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 className="m-0 font-weight-bold text-primary">Non-Generating Users</h6>
      </div>
      <div className="card-body">
        {loading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 160 }}>
            <div className="spinner-border text-primary me-2" role="status" aria-label="Loading non-generating users" />
            <span className="text-muted small">Loading...</span>
          </div>
        ) : users && users.length === 0 ? (
          <div className="text-center text-muted">There are currently no users with zero generation data.</div>
        ) : (
        <div className="table-responsive">
          <table className="table table-bordered" width="100%" cellSpacing={0}>
            <thead>
              <tr>
                <th rowSpan={2}>Consumer Name</th>
                <th rowSpan={2}>Provider Name</th>
                <th rowSpan={2}>Capacity (kWh)</th>
                <th colSpan={3} className="text-center">Energy Generation (kWh)</th>
              </tr>
              <tr>
                <th>{headerDates?.[0] || 'Day 1'}</th>
                <th>{headerDates?.[1] || 'Day 2'}</th>
                <th>{headerDates?.[2] || 'Day 3'}</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, idx) => (
                <tr key={idx}>
                  <td>{u.consumer_name}</td>
                  <td>{u.provider_name}</td>
                  <td>{u.capacity}</td>
                  {(() => {
                    const days = (u.last_three_days || u.energy_last_three_days || []) as Array<number | string>;
                    const last3 = days.slice(-3);
                    const padded = Array(3).fill('N/A');
                    for (let i = 0; i < last3.length; i++) padded[3 - last3.length + i] = last3[i];
                    return (
                      <>
                        <td>{padded[0]}</td>
                        <td>{padded[1]}</td>
                        <td>{padded[2]}</td>
                      </>
                    );
                  })()}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
    </div>
  );
};

export default NonGeneratingUsers;
